import styled from "@emotion/styled";
import { LocalTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import Flex from "../Generic/Flex";

interface Props {
  visitStartTime: LocalTime;
  visitEndTime: LocalTime;
  clockInToleranceMinutes: number;
  clockOutToleranceMinutes: number;
}

function ClockInOutRanges(props: Props) {
  return (
    <ClockInOutRanges.Root>
      <Flex xGap={5}>
        <ClockInOutRanges.Range>
          {translate(STRINGS.START_TIME) + ": " + props.visitStartTime.toString()}
        </ClockInOutRanges.Range>
      </Flex>
      <Flex xGap={5}>
        <ClockInOutRanges.Range>
          {translate(STRINGS.END_TIME) + ": " + props.visitEndTime.toString()}
        </ClockInOutRanges.Range>
      </Flex>
    </ClockInOutRanges.Root>
  );
}

ClockInOutRanges.Root = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #53606c;
  display: flex;
  direction: column;
  gap: 8px;
`;

ClockInOutRanges.Range = styled.div`
  font-weight: 800;
`;

export default ClockInOutRanges;
